import { render, staticRenderFns } from "./PaIndex.vue?vue&type=template&id=1e8379dc&scoped=true"
import script from "./PaIndex.vue?vue&type=script&lang=js"
export * from "./PaIndex.vue?vue&type=script&lang=js"
import style0 from "./PaIndex.vue?vue&type=style&index=0&id=1e8379dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e8379dc",
  null
  
)

export default component.exports